
const webApkInterface = {
    openInBrowser: async (url) => {
      
        new Promise((resolve, reject) => {
            try {
               

                if(window.Android){
                    console.log(url);
                    if (!url) {
                        return;
                    }
                    if (url === '#') {
                        return;
                    }
                    if (url === '') {
                        return;
                    } 
                   
                    window.Android.openInBrowser(url);
                   
                }else{
                    window.location.href = url;
                }
                resolve(true)
            } catch (err) {
                console.log(err);
                reject(false)
            }
        })
       
    } ,
    showToast:async (msg) => {
      

        try {
            // console.log('Android');
            // console.log('clicked showToast');

            window.Android.showToast(msg);

        } catch (err) {
            console.log(err);

        }
    },
    

};

export default webApkInterface;

